export const handleBigSearchParamsList = (fields: string[]): any[] =>
  fields.length < 21 && fields.length
    ? fields
    : Object.entries(fields).map(([_key, field]) => field);
